import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';

function sortingClassName(headerViewModel) {
  if (!headerViewModel.sortingAllowed) return '';
  switch (headerViewModel.sort) {
    case 'asc': return 'sorting_asc';
    case 'desc': return 'sorting_desc';
    default: return 'sorting';
  }
}

const TableHeaders = observer(({showLinks, uiState}) => {
  return (
    <tr>
      {uiState.headers.map((h, index) => (
        <th key={index} className={`col-${h.column.width} ${h.column.className || ''} ${sortingClassName(h)}`}>
          <span onClick={() => uiState.clickHeader(h)}>
            {h.column.header ? <FormattedMessage id={h.column.header}/> : <span>&nbsp;</span>}
          </span>
        </th>
      ))}
      {showLinks && <th>&nbsp;</th>}
    </tr>
  );
});

export default TableHeaders;
